import { ThunkAction } from "redux-thunk";
import { Dispatch, ActionCreator } from "redux";

import { RootState } from "../store/store";
import { resourcesType } from "../constanst/index";
import { Resources, Error, ResourceSelected } from "../types/resourceType";
import { resourcesAction } from "./IResourcesAction";
import { Exception } from "../types/exceptionType";

import axiosInstance from "../utils/axiosInstance";

export const fetchResourcesRequest = () => {
  return {
    type: resourcesType.FETCH_RESOURCES_REQUEST,
  };
};

export const fetchResourcesSuccess = (data: Resources) => {
  return {
    type: resourcesType.FETCH_RESOURCES_SUCCESS,
    payload: data,
  };
};

export const fetchResourcesFailure = (error: Error) => {
  return {
    type: resourcesType.FETCH_RESOURCES_FAILURE,
    payload: error,
  };
};

export const fetchCleanResources = () => {
  return {
    type: resourcesType.CLEAN_RESOURCES,
  };
};

export const resourceSelected = (data: ResourceSelected) => {
  return {
    type: resourcesType.RESOURCE_SELECTED,
    payload: data,
  };
};

export const fetchReports: ActionCreator<
  ThunkAction<void, RootState, null, resourcesAction>
> = () => {
  return (dispatch: Dispatch) => {
    dispatch(fetchResourcesRequest());
    axiosInstance
      .get("/resources")
      .then((response: any) => {
        const data: Resources = response.data;
        dispatch(fetchResourcesSuccess(data));
      })
      .catch((error: any) => {
        const data: Exception = {
          status: error.response.status,
          message: error?.response?.data,
          data: error.response?.data?.data,
        };
        dispatch(fetchResourcesFailure(data));
      });
  };
};

export const cleanResourcesList = () => {
  return (dispatch: Dispatch) => {
    dispatch(fetchCleanResources());
  };
};

export const resourceSelectedByUser = (id: string, name: string, type:string) => {
  return (dispatch: Dispatch) => {
    dispatch(resourceSelected({ id: id, name: name,  type:type }));
  };
};
